export default __webpack_public_path__ + "static/media/identity-fraud.864bf1cd.jpg";